import { setAuthorized } from './Actions/Office.jsx'

// TODO: implement other handlers for 400, 500, etc
export default function (error, dispatch) {
    console.error(error);
    if (error.status === 401) {
        dispatch(setAuthorized(false));
    }
}